import type { DSLQuery } from '@/shared/api/opensearch';
import type { TimeRange } from '@/shared/lib/utils/date-time/time-range';
import { getQueryRange } from '@/shared/lib/utils/query-range';
import dayjs from 'dayjs';

export const DEFAULT_OPENSEARCH_TIME_FIELD = '@timestamp';

// Missing settings belong to legacy widgets; an explicit empty string disables the range.
export const resolveOpensearchTimeField = (timeField?: string) =>
  timeField ?? DEFAULT_OPENSEARCH_TIME_FIELD;

export const getOpensearchTimeRangeQuery = (
  timeField: string,
  range: TimeRange,
): DSLQuery | undefined => {
  if (!timeField) return undefined;

  const { start, end } = getQueryRange(range);
  return {
    bool: {
      filter: [
        {
          range: {
            [timeField]: {
              gte: dayjs.unix(start).toISOString(),
              lte: dayjs.unix(end).toISOString(),
            },
          },
        },
      ],
    },
  };
};
